import { render } from "./ReceivingInstructions.vue?vue&type=template&id=05458892&ts=true"
import script from "./ReceivingInstructions.vue?vue&type=script&lang=ts"
export * from "./ReceivingInstructions.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__